import i18next from 'i18next';

/**
 * BHI program lifecycle states. Backend string values — keep
 * lowercase, must match API responses.
 */
export const BHI_STATUSES = {
  active: 'active',
  inactive: 'inactive',
};

/**
 * Display-ready options for the bhiStatus filter dropdown.
 */
export const BHI_STATUS_OPTIONS = [
  { label: i18next.t('tables:active'), value: BHI_STATUSES.active },
  { label: i18next.t('tables:inactive'), value: BHI_STATUSES.inactive },
];
